import React, { useEffect, useState } from 'react'
import { CircularProgress, Button } from '@material-ui/core'
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined';
import AddBoxOutlinedIcon from '@material-ui/icons/AddBoxOutlined';
import firebase from '../firebase'
import 'firebase/firebase-firestore'
import { withRouter } from 'react-router-dom'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import MenuIcon from '@material-ui/icons/Menu';
 import Drawer from '@material-ui/core/Drawer';
import TextField from '@material-ui/core/TextField';
import Backdrop from '@material-ui/core/Backdrop';
import CachedRoundedIcon from '@material-ui/icons/CachedRounded';
import Menu from '../Menu';


function Dashboard(props) {
	const days = ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sábado'];
	const [newReservation, setNewReservation] = useState(false);
	const [dialogDelete, setDialogDelete] = useState(false);
	const [deleteClass, setDeleteClass] = useState(false);
	const [listCLass, setListCLass] = useState([]);
	const [menuIsOpen, setMenuIsOpen] = useState(false);
	const [max, setMax] = useState(false);
	const [msjDate, setMsjDate] = useState('');
	const [msjHour, setMsjHour] = useState('');
	const [idAction, setIdAction] = useState('');
	const currentUser = firebase.getCurrentUsername();
	const [currentName, setCurrentName] = useState('');
	const [backdrop, setBackdrop] = useState(false);
	const [userData, setUserData] = useState();
	const [userPic, setUserpic] = useState();
	
	let actuallyDate = '';
	const baseURL = process.env.PUBLIC_URL;


/* Use Effect -------------------------------------------- */	

	useEffect (()=> {
		if(!currentUser) {
			return props.history.replace(baseURL+'/login')
			// sri WCn6bPhI2VcXR7CSIh3eUjMKOQT2
			// ronald FBmsaisANdW5K213MFMpq8wYHI72
			// admin Mqweip6UKUV8jWS1n4xHMC0jZXm2
		} else if (currentUser[0].uid == "Mqweip6UKUV8jWS1n4xHMC0jZXm2" || currentUser[0].uid == 'WCn6bPhI2VcXR7CSIh3eUjMKOQT2' || currentUser[0].uid == 'FBmsaisANdW5K213MFMpq8wYHI72'){
			return props.history.replace(baseURL+'/admin');
		} else{
			if(!currentUser[0].name){
				setCurrentName('');
			}else{
				setCurrentName(currentUser[0].name);
			}
			autoRegisterStudentProfile();
			getClasses();
		}
	},[]);

/* reserve class -------------------------------------------- */
	const bookClass = (e) => {
		setBackdrop(true);
		dialogCloseReservation();
		firebase.db.collection("class").doc(idAction).collection('attendance').get()
		.then(function(documentSnapshot) {
			let obj = {};
			if(documentSnapshot.docs.length < max){
				if(JSON.parse(localStorage.getItem('data')) !== null && JSON.parse(localStorage.getItem('data')) !== ''){
					let data = JSON.parse(localStorage.getItem('data'));
					obj.uid = data.uuid ? data.uuid : '';
					obj.user = data.name ? data.name : '';
					obj.email = data.email ? data.email : '';
					obj.nick = data.nick ? data.nick : '';
					obj.pic = data.pic ? data.pic : '';
					obj.belt = data.belt ? data.belt : '';
				} else{
					obj.uid = currentUser[0].uid;
					obj.user = currentUser[0].name;
					obj.email = currentUser[0].email;
					obj.nick = currentUser[0].name;
				}
				firebase.db.collection("class").doc(idAction).collection('attendance').add(obj)
				.then(function() {
					console.log("clase reservada");
					getClasses();
					setBackdrop(false);
				})
				.catch(function(error) {
					console.error("error al reservar la clase ", error);
					setBackdrop(false);
				});
			} else{
				setBackdrop(false);
				getClasses();
				console.error("No hay lugar");
			}

		}).catch(function(error) {
			console.error("error al reservar la clase ", error);
			dialogCloseDelete();
		});
	  };

/* delete reservation -------------------------------------------- */
const deleteReservation = () => {
	firebase.db.collection("class").doc(idAction).collection('attendance').doc(deleteClass).delete()
	.then(function() {
		console.log("clase eliminada");
		dialogCloseDelete();
		getClasses();
	})
	.catch(function(error) {
		console.error("problema al eliminar la clase", error);
		dialogCloseDelete();
	});
  };
	  
/* Dialog book -------------------------------------------- */	
	const dialogOpenReservation = (date, hour, id, max) => {
		setMsjDate(date);
		setMsjHour(hour);
		setIdAction(id);
		setMax(max);
		setNewReservation(true);
	  };
	
	  const dialogCloseReservation = () => {
		setNewReservation(false);
	  };
 

/* Dialog delete -------------------------------------------- */	
const dialogOpenDelete = (date, hour, id, idClass) => {
	setMsjDate(date);
	setMsjHour(hour);
	setIdAction(id);
	setDeleteClass(idClass);
	setDialogDelete(true);
  };

  const dialogCloseDelete = () => {
	setDialogDelete(false);
  };
		
/* Data Register -------------------------------------------- */	
const autoRegisterStudentProfile = () => {
	firebase.db.collection("students").where("email", "==", currentUser[0].email).get().then((querySnapshot) => {
		console.log(querySnapshot.size);
		if (querySnapshot.size == 0) {
			let obj = {
				name: currentUser[0].name,
				nick: currentUser[0].name,
				email: currentUser[0].email,
				uuid: currentUser[0].uid,
			};
			firebase.db.collection("students").add(obj)
			.then(function() {
				console.log("usuario almacenado en nueva tabla");
				setUserData(obj);
			})
			.catch(function(error) {
				console.error("error en el registro de la nueva clase", error);
			});
		} else {
			setUserData(querySnapshot.docs[0].data());
			setUserpic(querySnapshot.docs[0].data().pic);
		}
	});
}

/* reder -------------------------------------------- */	

	 const getClasses = () => {
		setBackdrop(true);
		const now = new Date(Date.now());
		let nowAux = new Date(Date.now());
		const end = new Date(nowAux.setDate(nowAux.getDate() + 2));
		let attendance = undefined;
		const list = firebase.db.collection("class").where("date", ">=", now).where('date', '<', end).orderBy('date');
		list.onSnapshot(function (querySnapshot) {
			const docs = [];
			querySnapshot.forEach( function (doc) {
				const attents = [];
				let assistence = undefined;
				attendance = firebase.db.collection("class").doc(doc.id).collection("attendance");
				attendance.onSnapshot(function (querySnapshot2) {
					querySnapshot2.forEach( function (doc2) {
						assistence = currentUser[0].uid == doc2.data().uid ? true : false;
						attents.push({...doc2.data(), id: doc2.id, assisted: assistence });
					})
				});
				docs.push({...doc.data(), id: doc.id, att: attents, disponibles: doc.data().max - attents.length, reserva: attents.find(element => element.assisted == true)});
			});
			setTimeout(()=>{
				setListCLass(docs);
				console.log(docs);
				setBackdrop(false);
			   }, 1000)
		}); 
	}
/* Menu -------------------------------------------- */	

	const openMenu = () => {
		setMenuIsOpen(!menuIsOpen);
	};

/* refresh -------------------------------------------- */	

	const refresh = () => {
		getClasses();
	};

/* reder -------------------------------------------- */		
if (listCLass.length > 0 && userData){
	if(localStorage.getItem('data') == null){
		localStorage.setItem('data', JSON.stringify(userData));
		localStorage.setItem('pic', userData.pic);
	}
	return (
		<main>
			<div className="loader"></div>
			<Backdrop className="backdrop"  open={backdrop}>
				<CircularProgress color="inherit" />
			</Backdrop>
			<header className="header-dashboard">
				<MenuIcon onClick={openMenu} />
				<h3>Reservas</h3>
				<CachedRoundedIcon onClick={refresh}  />
			</header>
			<section className="container">
				{ listCLass.map(classData => { 
					// conditions 
					let reserved = classData.att.find(element => element.assisted == true);
					let soldOut = classData.max - classData.att.length <= 0 ? true : false;
					let classNames = require('classnames');
					let liClasses = classNames({
						'reserved': reserved,
						'soldOut': soldOut,
						'class' : true
					  });
					let idClassReserved = classData.att.find(element => element.uid == currentUser[0].uid);
					let dateToShow= days[classData.date.toDate().getDay()] + " " + classData.date.toDate().getDate() + "/" +((classData.date.toDate().getMonth() + 1) < 10 ? '0' : '') + (classData.date.toDate().getMonth()+1);
					let hourToShow=  classData.date.toDate().getHours() + ":"+ (classData.date.toDate().getMinutes() < 10 ? '0' : '') + classData.date.toDate().getMinutes();
					
					if(classData.date.toDate().getDate() != actuallyDate){
						actuallyDate = classData.date.toDate().getDate();
						return <React.Fragment> 
							<div key={classData.id + "-header"} className="header-date">
								<div className="date-title">{dateToShow}</div>
								<div className="free-title">Clases</div>
								<div className="free-title">Libres</div>
								<div></div>
							</div>
							<div key={classData.id} className={liClasses}>
								<div className="class-hour">{hourToShow}</div>
								<div className="class-discipline">{classData.discipline}</div>
								<div className="class-available">{reserved ? "RESERVADO" : classData.max - classData.att.length }</div>
								{!reserved ?
								<div className="class-reserva action"><AddBoxOutlinedIcon onClick={() => {!soldOut ? dialogOpenReservation(dateToShow, hourToShow, classData.id, classData.max): console.log('SoldOut')}}/></div>
								:
								<div className="class-borrar action"><DeleteForeverOutlinedIcon onClick={() => dialogOpenDelete(dateToShow, hourToShow, classData.id, idClassReserved.id)} /></div>
							}
							</div>
						</React.Fragment>	
					} else {
					return<div key={classData.id + "-list"} className={liClasses}>
							<div className="class-hour">{hourToShow}</div>
							<div className="class-discipline">{classData.discipline}</div>
							<div className="class-available">{reserved ? "RESERVADO" : classData.max - classData.att.length }</div>
							{!reserved ?
								<div className="class-reserva action"><AddBoxOutlinedIcon onClick={() => {!soldOut ? dialogOpenReservation(dateToShow, hourToShow, classData.id, classData.max): console.log('SoldOut')}} /></div>
								:
								<div className="class-borrar action"><DeleteForeverOutlinedIcon onClick={() => dialogOpenDelete(dateToShow, hourToShow, classData.id, idClassReserved.id)} /></div>
							}
						</div>
					}
					})}
			</section>
			<Dialog
				open={newReservation}
				onClose={dialogCloseReservation}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">{"Vas a realizar la siguiente reserva"}</DialogTitle>
				<DialogContent>
				<DialogContentText id="alert-dialog-description">
					{msjDate} a las {msjHour} Hrs
				</DialogContentText>
				</DialogContent>
				<DialogActions>
				<Button onClick={dialogCloseReservation} color="primary">
					CANCELAR
				</Button>
				<Button onClick={bookClass} color="primary">
					RESERVAR
				</Button>
				</DialogActions>
			</Dialog>

			<Dialog
				open={dialogDelete}
				onClose={dialogCloseDelete}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">{"Vas a eliminar la siguiente reserva"}</DialogTitle>
				<DialogContent>
				<DialogContentText id="alert-dialog-description">
					{msjDate} a las {msjHour} Hrs
				</DialogContentText>
				</DialogContent>
				<DialogActions>
				<Button onClick={dialogCloseDelete} color="primary">
					CANCELAR
				</Button>
				<Button onClick={deleteReservation} color="primary">
					ELIMINAR
				</Button>
				</DialogActions>
			</Dialog>

			<Drawer anchor="left" open={menuIsOpen} onClose={openMenu} >
				<Menu />
			</Drawer>
		</main>
	)
 } else{
	 return (
		 <div className="loading">
		 	<CircularProgress />
		 </div>
	 )
 }
}

export default withRouter(Dashboard)